import React, { useState } from 'react'
import { padHourTime } from 'lib/utilities'

export function SubmissionHoursDropdown({ propertyPageUrl, scheduleByDay = [], style, panelStyle }) {
  const [expanded, setExpanded] = useState(false)

  const anyHasMinutes = scheduleByDay.some(
    ({ opens_at, closes_at }) => /\d:\d/.test(opens_at ?? '') || /\d:\d/.test(closes_at ?? '')
  )

  const formatHours = ({ opens_at, closes_at, timezone_short }) => {
    if (!opens_at) return 'closed'
    const close = (anyHasMinutes ? padHourTime(closes_at) : closes_at) ?? ''
    return `${padHourTime(opens_at)} - ${padHourTime(close)}${timezone_short ? ` ${timezone_short}` : ''}`.trim()
  }

  return (
    <div className="submission-hours-dropdown" style={style}>
      <button
        type="button"
        className="submission-hours-toggle dome-d-flex dome-align-center dome-gap3"
        onClick={() => setExpanded(!expanded)}
      >
        <span className="dome-p2 dome-color-darkest-grey dome-text-w500">submission hours</span>
        <i className={`fa-regular fa-angle-${expanded ? 'up' : 'down'} dome-color-med-grey`} aria-hidden="true" />
      </button>
      {expanded && (
        <div className="submission-hours-panel" style={panelStyle}>
          <ul className="submission-hours-list">
            {scheduleByDay.map((entry, index) => (
              <li key={entry.day_name ?? index} className="submission-hours-row">
                <span className="dome-p1 dome-color-dark-grey">{entry.day_name}</span>
                <span className="dome-p2 dome-color-med-grey">{formatHours(entry)}</span>
              </li>
            ))}
          </ul>
          {propertyPageUrl && (
            <div className="submission-hours-exclusions">
              <a
                href={propertyPageUrl}
                target="_blank"
                rel="noreferrer"
                style={{ color: 'var(--aqua, #0091A3)' }}
                className="dome-text-w500"
              >
                exclusions apply →
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default SubmissionHoursDropdown
